import { identityService } from "../profile/identityService_v2.js";
import { matchService } from "./matchService_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { colors } from "../colors_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { zoom } from "../zoom_v2.js";
import { dasModal } from "../modal_v2.js";
import { matchDraw } from "./matchDraw_v2.js";
import { resign } from "./matchResign_v2.js";
import { cancel } from "./cancelMatch_v2.js";
import { COMPUTER_NAME, COMPUTER_USERID, MESSAGE_MAX_LENGTH } from "../constants_v2.js";
import { iPop } from "../ipop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { identityCard } from "../profile/identityCard_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { generateARRs } from "../game/utils-game_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

var currentMatchState = {
  size: "small",
  currentMatch: "Loading...", // the id of the current match
  matches: [], //contains type match. It's only the ones currently loaded into memory
  filters: {
    playerFilter: true, //default
    watcherFilter: false,
    ownerFilter: false,
    activeFilter: true, //default
    finishedFilter: false,
  },
  page: 0,
  itemsOnPage: 5,
  totalPages: 1,
};

const getSize = () => {
  return currentMatchState.size;
};

//always in the dom:
const currentMatchNav = document.getElementById("currentMatchNav");

const render = async (size) => {
  currentMatchNav.classList.add("sectionNarrow");

  const currentMatchSection = document.getElementById("currentMatchSection");
  switch (size) {
    case "normal":
      const modalBehinder = document.getElementById("modalBehinder");
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "ModalBehinderCloseCurrentMatch";
      currentMatchState.size = "normal";
      currentMatchSection.style.width = utilsApp.calculateSectionWidth();
      const htmlNormal = `
          <div id="sectionHeaderArea" class="vertical">
            <div id="ymMenu" class="menu">Current Match</div>
          </div>
          <div id="wmRightSide">
            <div id=ymTopRow>
              <div id=ymMiddle>
                <div id="activeMatch">
                  <span class="currentMatchHeader">Current Match: </span><div class="pillBox courier inline" id="currentMatchState"></div><div id="stateSplainer" class="i">ⓘ</div>
                  <div class="font15" id="currentMatch"></div>
                </div>
              </div>
              <div id="ymButtons"> 
              </div>
            </div>
          </div>
          <div id="closeYourMatches" class="x"></div>
      `;
      currentMatchSection.innerHTML = htmlNormal;
      currentMatchSection.classList.add("sectionWide");
      await renderMatches();
      colors.setButtonColors();
      if (document.body.contains(document.getElementById("copied"))) {
        document.getElementById("copied").classList.add("hide");
      }
      utilsApp.adjust4Mobile();
      break;
    case "small":
      currentMatchSection.style.width = "0px";
      currentMatchSection.innerHTML = "";
      currentMatchSection.className = "";
      currentMatchState.size = "small";
      break;
    default:
      console.log(
        "Error: Attempting to render currentMatch to invalid size: " + size,
      );
      return;
  }
  colors.setNavColors();

  currentMatchSection.style.borderColor = colors.getGameColor("hexGrid");
  currentMatchNav.style.borderColor = colors.getGameColor("hexGrid");
};

const generateStateSplainerHTML = (state) => {
  let text;
  switch (state) {
    case "pending":
      text =
        "Pending means there are no moves yet. The owner can cancel the match or remove the opponent.";
      break;
    case "started":
      text =
        "Started means the match is now in progess. After the first move, the owner can no longer cancel the match or remove the opponent.";
      break;
    case "finished":
      text = "Finished means the match is over.";
      break;
    case "drawOffered":
      text =
        "Draw Offered means that one player has suggested a draw, but the other player has not decided yet. It would mean nobody wins or loses.";
      break;
    case "drawDeclined":
      text =
        "Draw Declined means that one player offered a draw, but the other player wants to keep playing.";
      break;
    case "draw":
      text =
        "A Draw means the players agreed to a draw. The match is over and nobody won.";
      break;
    case "abandoned":
      text = `Matches are abandoned when: 
        <p>1) An player's account (or temporary identity) was deleted.</p>
        <p>2) No moves were made for a month.`;
      break;
    case "notifyResign":
      text =
        "Notify Resign means that one player has resigned, but the other player has not seen it yet. The player who resigned has lost.";
      break;
    case "notifyCancel":
      text =
        "Notify Cancel means that the owner has cancelled a match that was in pending state, but the other player has not seen it yet. Cancelled matches do not affect ratings. Only Pending matches can be cancelled.";
      break;
    case undefined:
      text = "There is no current match";
  }
  return text;
};

const renderStateSplainer = (event) => {
  const result = matchService.getCurrentMatch();
  const state = result.currentMatch.state;
  const matchID = result.currentMatch.matchID;
  let text = "There is no current match.";
  text = generateStateSplainerHTML(state);
  text =
    text +
    `<br><br><div style="text-align:right; color:gray; font-size:14px;">The matchID is: <em>${matchID ? matchID : "n/a"}</em></div>`;
  iPop.render({
    text,
    event,
  });
};

const close = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const handleCurrentMatchClick = () => {
  switch (getSize()) {
    case "small":
      render("normal");
      break;
    case "normal":
      render("small");
      break;
    default:
      render("small");
  }
};

const renderMatches = async () => {
  if (currentMatchState.size === "normal") {
    const currentMatchElement = document.getElementById("currentMatch");
    const result = matchService.getCurrentMatch();
    const match = result.currentMatch;

    const { p1ARR, p2ARR } = generateARRs({ match, style: "long" });

    // SECURITY: player names are user-entered, so they're escaped.
    let p1Turn = escapeHtml(match.p1Name);
    if (match.p1Name != COMPUTER_USERID && match.p1Name != "waiting") {
      let p1UserID = identityService.parseUserID(match.p1Name);
      let p1NamePart = identityService.parseName(match.p1Name);
      p1Turn = `${escapeHtml(p1NamePart)} <span class='pAUserIDColor'>(${escapeHtml(p1UserID)})</span>`;
    }
    let p2Turn = escapeHtml(match.p2Name);
    if (match.p2Name != COMPUTER_USERID && match.p2Name != "waiting") {
      let p2UserID = identityService.parseUserID(match.p2Name);
      let p2NamePart = identityService.parseName(match.p2Name);
      p2Turn = `${escapeHtml(p2NamePart)} <span class='pAUserIDColor'>(${escapeHtml(p2UserID)})</span>`;
    }
    if (match.turn === match.p1UserID) {
      p1Turn = "<em>" + p1Turn + "</em>";
    }
    if (match.turn === match.p2UserID) {
      p2Turn = "<em>" + p2Turn + "</em>";
    }

    switch (result.status) {
      case 200:
        currentMatchElement.innerHTML = `
          <div class="flexDirRow" id="yourMatchesOwnerRow">
            <div id="yourMatchesP1" class="bottom5">Playing First:
              <div class="yourMatchesPlayer">${p1Turn}</div>
              <div class="flexDirColum">
                <div class="flexDirRow">
                  <div id="p1IsOwner" class="pillBox ymPill"></div>
                  <div id="p1sTurn" class="pillBox ymPill"></div>
                  
                </div>
                <div class="flexDirRow">
                  <div id="p1IsWinner" class="pillBox wmWinnerPill"></div>
                  <div id="p1IsDrawOffered" class="pillBox wmWinnerPill"></div>
                <div>
                <div class="flexDirRow"><div class="ARRLongWidth">${p1ARR}</div>
                </div>
              </div>  
            </div>
          </div>
          </div>
            <div id="yourMatchesP2" class="bottom5">Playing Second:
              <div class="yourMatchesPlayer">${p2Turn}</div>
              <div class="flexDirColum">
                <div class="flexDirRow">
                  <div id="p2IsOwner" class="pillBox ymPill"></div>
                  <div id="p2sTurn" class="pillBox ymPill"></div>
                  
                </div>
                <div class="flexDirRow">
                  <div id="p2IsWinner" class="pillBox wmWinnerPill"></div>
                  <div id="p2IsDrawOffered" class="pillBox wmWinnerPill"></div>
                </div>
                <div class="flexDirRow"><div class="ARRLongWidth">${p2ARR}</div>
                </div>
              </div>
            </div>
          </div>
          `;

        // if we just watching a match we do not own and are not playing in, then we don't get
        // the codes
        const pAIdentityIsJustWatching = await justWatching(match);
        if (pAIdentityIsJustWatching === false && match.active === "active") {
          currentMatchElement.innerHTML =
            currentMatchElement.innerHTML +
            (await codesHTML(result.currentMatch));
        }
        // await renderButtons(result.currentMatch);

        // Add message display if present - insert before codes section
        if (match.message && match.message.trim().length > 0) {
          const sanitizedMessage = utilsApp.sanitizeMessage(match.message);
          const messageContainer = document.createElement('div');
          messageContainer.className = 'currentMatchMessageSection';
          messageContainer.innerHTML = `
            <span class="currentMatchMessageLabel">Invitation Message:</span><span class="i" id="currentMatchMessageSplainer">ⓘ</span><br>
            <div class="currentMatchMessageText">${sanitizedMessage}</div>
          `;
          // Set background color to match new match message section
          messageContainer.style.backgroundColor = colors.getGameColor("tip");
          messageContainer.style.borderRadius = "10px";
          messageContainer.style.padding = "7px";
          messageContainer.style.margin = "7px";
          // Set width to fit content like the code row
          messageContainer.style.width = "fit-content";
          messageContainer.style.maxWidth = "100%";
          // Always directly under the players (and above the join codes, if
          // any). It used to go next to the buttons column when there were
          // no codes (finished matches, watchers), which pushed the buttons
          // outside the dialog.
          const ownerRow = document.getElementById("yourMatchesOwnerRow");
          if (ownerRow) {
            ownerRow.insertAdjacentElement("afterend", messageContainer);
          }
        }

        await renderButtons(result.currentMatch);
        setFlexDir();
        renderBackgrounds();
        renderOwnerTurnWinner(result.currentMatch);
        renderState(result.currentMatch.state);
        // renderVisibility(result.currentMatch.visibility);

        break;
      case 404:
        currentMatchElement.innerHTML = `
        <br>
        There isn't a current match.<br>
        Try starting a new one or checking if someone sent you a join code.`;
        break;
    }
  }
};

const renderARRSplainerLong = (event) => {
  const text = `
  <div>
    Actions taken in this match by the player
  </div>`;
  iPop.render({
    text,
    event,
  });
};

const justWatching = async (match) => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;

  const pAUserID = pAIdentity.userID;
  const ownerUserID = match.ownerUserID;
  const p1UserID = match.p1UserID;
  const p2UserID = match.p2UserID;
  if (pAUserID === ownerUserID) {
    return false; // we are the owner, so we are not just watching someone else's match
  }
  if (pAUserID === p1UserID) {
    return false; // we are a player, so we are not just watching someone else's match
  }
  if (pAUserID === p2UserID) {
    return false; // we are a player, so we are not just watching someone else's match
  }
  return true; // we are not the owner nor are we a player
};

const playerCodeP1Html = (match) => {
  if (Object.keys(match).includes("playerCodeP1")) {
    return `<li><div class="bottom5"><span id="playerCodeP1Span" class="courier">${match.playerCodeP1}</span>
          <div class="copyIcon" id="playerCodeP1Div"></div></div>
          <div><span class="nowrap"><a class="joinURL" href="https://topagon.com/join?${match.playerCodeP1}">https://topagon.com/join?${match.playerCodeP1}</a><div class="copyIcon" id="copyP1JoinURL"></div></span></div>
          </li>`;
  }
  return `<li><button class="codeButtons" id="generatePlayerCodeP1">Get Playing First Code</button></li>`;
};

const playerCodeP2Html = (match) => {
  if (Object.keys(match).includes("playerCodeP2")) {
    return `<li><div class="bottom5"><span id="playerCodeP2span" class="courier">${match.playerCodeP2}</span>
          <div class="copyIcon" id="playerCodeP2Div"></div></div>
          <div><span class="nowrap"><a class="joinURL" href="https://topagon.com/join?${match.playerCodeP2}">https://topagon.com/join?${match.playerCodeP2}</a><div class="copyIcon" id="copyP2JoinURL"></div></span></div>
          </li>`;
  }
  return `<li><button class="codeButtons" id="generatePlayerCodeP2">Get Playing Second Code</button></li>`;
};

const watcherCodeHtml = (match) => {
  if (Object.keys(match).includes("watcherCode")) {
    return `<li><div class="bottom5"><span id="watcherCodeSpan" class="courier">${match.watcherCode}</span>
          <div class="copyIcon" id="watcherCodeDiv"></div></div>
          <div><span class="nowrap"><a class="joinURL" href="https://topagon.com/join?${match.watcherCode}">https://topagon.com/join?${match.watcherCode}</a><div class="copyIcon" id="copyWatcherURL"></div></span></div>
          </li>`;
  }
  return `<li><button class="codeButtons" id="generateWatcherCode">Get Watcher Code</button></li>`;
};

const codesHTML = async (match) => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;
  const ownerUserID = match.ownerUserID;
  const p1UserID = match.p1UserID;
  const p2UserID = match.p2UserID;
  let html = `
      <div id="YourMatchesCodeRow">
        <span class="currentMatchMessageLabel">Join Code(s):</span>
        <ul>`;
  switch (true) {
    case pAUserID === ownerUserID &&
      pAUserID != p1UserID &&
      pAUserID != p2UserID:
      // An owner who is not playing gets all the join codes,
      // but only if they exist.
      // If the codes don't exist, then they get a button to get them only if we are waiting
      if (p1UserID === "waiting") {
        html = html + playerCodeP1Html(match);
      }
      if (p2UserID === "waiting") {
        html = html + playerCodeP2Html(match);
      }
      html = html + watcherCodeHtml(match); // watcher code or button to get them
      break;
    case pAUserID === ownerUserID && pAUserID === p1UserID:
      // An owner who is player one gets the p2 codes and watcher codes, if they exist
      // i.e. nobody can join as P1 in this case
      // If the codes don't exist, then they get a button to get them, but only
      // if we are waiting
      if (p2UserID === "waiting") {
        html = html + playerCodeP2Html(match);
      }
      html = html + watcherCodeHtml(match); // watcher code or button to get them
      break;
    case pAUserID === ownerUserID && pAUserID === p2UserID:
      // An owner who is player two gets the p1 codes and watcher codes, if they exist
      // i.e. nobody can join as P2 in this case
      // If the codes don't exist, then they get a button to get them, but only
      // if we are waiting
      if (p1UserID === "waiting") {
        html = html + playerCodeP1Html(match);
      }
      html = html + watcherCodeHtml(match); // watcher code or button to get them
      break;
    case pAUserID != ownerUserID &&
      (pAUserID === p1UserID || pAUserID === p2UserID):
      // players who are not owners get the watcher code, if it exists
      html = html + watcherCodeHtml(match); // watcher code or button to get them
    default:
      // participants who are not the owner and not a player don't get any codes
      break;
  }

  html =
    html +
    `</ul><div class="hide copied" id="copied"><em>Copied!</em></div></div>`;
  return html;
};

const resumeMatchButton = ({ match, pAUserID }) => {
  // you can only resume if there was a draw and it was declined.
  // in same device mode, always show the button when in this state
  // on own device mode, only show the button when in this state if the turn is the logged on user
  let html = ``;
  if (
    match.state === "drawDeclined" &&
    (match.turn === pAUserID || match.mode === "sameDevice")
  ) {
    html = `<button id="ymResume" class="curentMatchButtons">Resume Match</button>`;
  }
  return html;
};

const drawButton = async ({ match, pAUserID }) => {
  // you can only offer a draw or resign from a match that has been started (e.g. at least one piece on the board)
  // in same device mode, always show the button when in started except if playing
  // against the computer. In that case, you can't offer a draw.
  // on own device mode, only show the button when in started AND when the turn is the logged on user
  let html = ``;
  if (
    match.state === "started" &&
    match.p1UserID != COMPUTER_USERID &&
    match.p2UserID != COMPUTER_USERID &&
    (await matchService.pAIsPlayer()) === true &&
    (match.turn === pAUserID || match.mode === "sameDevice")
  ) {
    html = `<button id="offerDraw" class="curentMatchButtons">Offer Draw</button>`;
  }
  return html;
};

const resignButton = async ({ match, pAUserID }) => {
  // you can only offer a draw or resign from a match that has been started (e.g. at least one piece on the board)
  // in same device mode, always show the button when in started
  // on own device mode, only show the button when in started AND when the turn is the logged on user
  let html = ``;
  const isPlayer = await matchService.pAIsPlayer();
  if (!isPlayer) {
    return html;
  }
  if (
    match.state === "started" &&
    (match.turn === pAUserID || match.mode === "sameDevice")
  ) {
    html = `<button id="resignButton" class="curentMatchButtons">Resign</button>`;
  }
  return html;
};

const manageWatchersButtonText = (match) => {
  return `Manage ${match.watchers.length} Watchers`;
};

const manageWatcherButton = async ({ match, pAUserID }) => {
  // players and owners can always manage watchers, if there are any
  const watchers = match?.watchers ?? [];
  const isPlayer = await matchService.pAIsPlayer();
  if (!isPlayer) {
    return ``;
  }
  // No watchers: no button. (It used to show a "There are no watchers"
  // label styled like a button, which looked clickable but did nothing.)
  let html = ``;
  if (watchers.length > 0) {
    html = `<button id="manageWatchersButton" class="bottom7 curentMatchButtons">${manageWatchersButtonText(
      match,
    )}</button>`;
  }
  return html;
};

const removePlayerButtons = ({ match, pAUserID }) => {
  // only the owner can remove players if the match is still pending
  let html = ``;

  if (
    pAUserID === match.ownerUserID &&
    match.p1UserID === COMPUTER_USERID &&
    match.state === "pending"
  ) {
    return `<button id="removeP1" class="bottom7 curentMatchButtons">
          Remove ${COMPUTER_NAME}</button>`;
  }

  if (
    pAUserID === match.ownerUserID &&
    match.p2UserID === COMPUTER_USERID &&
    match.state === "pending"
  ) {
    return `<button id="removeP2" class="bottom7 curentMatchButtons">
          Remove ${COMPUTER_NAME}</button>`;
  }

  if (pAUserID === match.ownerUserID && match.state === "pending") {
    // What if the wrong player joins as opponent?
    // The owner can remove them, but only if the match hasn't started yet
    if (match.ownerUserID != match.p1UserID && match.p1UserID != "waiting") {
      html =
        html +
        `<button id="removeP1" class="bottom7 curentMatchButtons">
          Remove ${escapeHtml(identityService.parseName(match.p1Name))}</button>`;
    }
    if (match.ownerUserID != match.p2UserID && match.p2UserID != "waiting") {
      html =
        html +
        `<button id="removeP2" class="bottom7 curentMatchButtons">
          Remove ${escapeHtml(identityService.parseName(match.p2Name))}</button>`;
    }
  }
  return html;
};

const cancelButton = ({ match, pAUserID }) => {
  let html = ``;
  if (match.state === "pending" && pAUserID === match.ownerUserID) {
    // you can only cancel if the logged on user is the owner and it hasn't started yet
    html =
      html +
      `<button id="cancelButton" class="bottom7 curentMatchButtons">Cancel</button>`;
  }
  return html;
};

const decideDrawButton = ({ match, pAUserID }) => {
  let html = ``;
  if (match.state === "drawOffered" && pAUserID != match.turn) {
    // you can only decide on the draw if it's not your turn. That's becasue the other guy
    // can only offer the draw on their turn, and that doesn't change the turn.
    html =
      html +
      `<button id="decideDrawButtonCurrentMatchButton" class="bottom7 curentMatchButtons">Decide Draw</button>`;
  }
  return html;
};

const stopWatchingButton = ({ match, pAUserID }) => {
  let html = ``;
  const watchers = match?.watchers ?? [];
  if (match.active === "active" && watchers.includes(pAUserID)) {
    // you can only decide on the draw if it's not your turn. That's becasue the other guy
    // can only offer the draw on their turn, and that doesn't change the turn.
    html =
      html +
      `<button id="stopWatchingButton" class="bottom7 curentMatchButtons">Stop Watching</button>`;
  }
  return html;
};

const withdrawButton = async ({ match, pAUserID }) => {
  // if the pAUserID is just watching or the owner, they don't get a withdraw button
  if (!(await matchService.pAIsPlayer())) {
    return ``;
  }
  if (await matchService.pAIsOwner()) {
    return ``;
  }
  const moves = match?.moves ?? [];
  for (const move of moves) {
    if (move.player === pAUserID) {
      // if the pAUserID has made any moves, then they don't get a withdraw button
      return ``;
    }
  }
  const html = `
  <div class="noWrap">
    <button id="withdrawButton" class="bottom7 curentMatchButtons" style="width:81px;">Withdraw</button>
    <div id="withdrawSplainer" class="i">ⓘ</div>
  </div>`;
  return html;
};

const renderWithdrawSplainer = (event) => {
  iPop.render({
    text: "You can only withdraw from a game if it's in pending status. It can't be undone. Once you withdraw, you will not be able to get into the match again.",
    event,
  });
};

const renderCurrentMatchMessageSplainer = (event) => {
  iPop.render({
    text: "Invitation Messages are created by the match owner. They can not be changed at this point.",
    event,
  });
};

const renderButtons = async (match) => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;

  let html = ``;
  html = html + (await manageWatcherButton({ match, pAUserID }));
  html = html + resumeMatchButton({ match, pAUserID });
  html = html + (await drawButton({ match, pAUserID }));
  html = html + (await resignButton({ match, pAUserID }));
  html = html + removePlayerButtons({ match, pAUserID });
  html = html + cancelButton({ match, pAUserID });
  html = html + decideDrawButton({ match, pAUserID });
  html = html + stopWatchingButton({ match, pAUserID });
  html = html + (await withdrawButton({ match, pAUserID }));

  document.getElementById("ymButtons").innerHTML = html;
};

const handleWithdrawButton = () => {
  const html = `<div class="max flexColumn">
  <br>
  <br>
  <div>Are you sure you want to withdraw from this match?</div>
  <br><br>
  <div class="flexRow">
    <button class="ruSure" id=yesWithdraw>Yes</button>
    <button class="ruSure" id=noWithdraw>No</button></div>
  </div>
    <div class="courier" id="withdrawMsg"></div>
  </div>`;
  dasModal.render(html);
};

const handleNoWithdraw = () => {
  dasModal.close();
};

const handleYesWithdraw = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return;
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;
  const withdrawMsg = document.getElementById("withdrawMsg");
  const yesWithdraw = document.getElementById("yesWithdraw");
  document.body.style.cursor = "wait";
  yesWithdraw.style.cursor = "wait";
  yesWithdraw.disabled = true;
  withdrawMsg.textContent = "Submitting...";
  const withdrawResult = await matchService.removePlayer(pAUserID);
  document.body.style.cursor = "default";
  yesWithdraw.style.cursor = "default";
  yesWithdraw.disabled = false;
  withdrawMsg.textContent = "";

  dasModal.close();
  if (withdrawResult.status != 200) {
    dasModal.render(`
      <div class="max">
        <br><br>
        There was an error when attempting to stop watching the match:<br>
        <br>
        <span class="courier">${escapeHtml(withdrawResult?.message ?? "unknown error")}</span>
      </max>
      `);
  }

  await matchService.setCurrentMatchID("noCurrentMatch");
  board.render();
  scoreBoard.render();
  close();
};

const handleStopWatchingButton = () => {
  const html = `<div class="max flexColumn">
  <br>
  <br>
  <div>Are you sure you want to stop watching this match?</div>
  <br><br>
  <div class="flexRow">
    <button class="ruSure" id=yesStop>Yes</button>
    <button class="ruSure" id=noStop>No</button></div>
  </div>
    <div class="courier" id="stopMsg"></div>
  </div>`;
  dasModal.render(html);
  board.render(); // update the current(1) button
};

const handleNoStop = () => {
  dasModal.close();
};

const handleYesStop = async () => {
  const stopMsg = document.getElementById("stopMsg");
  const yesStop = document.getElementById("yesStop");
  document.body.style.cursor = "wait";
  yesStop.style.cursor = "wait";
  yesStop.disabled = true;
  stopMsg.textContent = "Submitting...";
  const stopResult = await matchService.stopWatching();
  document.body.style.cursor = "default";
  yesStop.style.cursor = "default";
  yesStop.disabled = false;
  stopMsg.textContent = "";

  dasModal.close();
  if (stopResult.status != 200) {
    dasModal.render(`
      <div class="max">
        <br><br>
        There was an error when attempting to stop watching the match:<br>
        <br>
        <span class="courier">${escapeHtml(stopResult?.message ?? "unknown error")}</span>
      </max>
      `);
  }

  await matchService.setCurrentMatchID("noCurrentMatch");
  board.render();
  scoreBoard.render();
  close();
};

const handleRemovePlayer = async (event, element) => {
  const gotClicked = element.id;
  if (!["removeP1", "removeP2"].includes(gotClicked)) {
    return; // something is wrong..
  }
  const result = await matchService.getCurrentMatch();
  if (result.status != 200) {
    return; //no current match
  }
  const match = result.currentMatch;
  const name2BRemoved = gotClicked === "removeP1" ? match.p1Name : match.p2Name;
  currentMatchState.player2BRemoved = gotClicked; // keep track
  dasModal.render(
    `<br>
    <div class=max style="flex-direction:column;">Are you sure you want to remove<br><br> ${escapeHtml(name2BRemoved)}?<br><br>
      <div style="flex-direction:row">
        <button class="ruSure" id="yesRemove">Yes</button>
        <button class="ruSure" id="noRemove">No</button>
      </div>
      <div class="courier" id="yesRemoveMsg"></div>
    </div>`,
  );
};

const handleNoRemove = () => {
  delete currentMatchState.player2BRemoved;
  dasModal.close();
};

const handleYesRemove = async () => {
  const result = matchService.getCurrentMatch();
  if (result.status != 200) {
    return; //no current match
  }
  const match = result.currentMatch;
  const player2BRemoved = currentMatchState.player2BRemoved;
  if (typeof player2BRemoved === "undefined") {
    return; // something is wrong...
  }
  var resultRemove = {};
  const yesRemove = document.getElementById("yesRemove");
  const yesRemoveMsg = document.getElementById("yesRemoveMsg");
  yesRemoveMsg.innerText = "Submitting...";
  document.body.style.cursor = "wait";
  yesRemove.style.cursor = "wait";
  switch (player2BRemoved) {
    case "removeP1":
      resultRemove = await matchService.removePlayer(match.p1UserID);
      break;
    case "removeP2":
      resultRemove = await matchService.removePlayer(match.p2UserID);
      break;
  }
  document.body.style.cursor = "default";
  yesRemove.style.cursor = "default";
  yesRemoveMsg.innerText = "";
  if (resultRemove.status != 200) {
    dasModal.render(
      `<div class=max>Error: Unable to remove the player. Try refreshing the browser.</div>`,
    );
  }
  render("normal");
  //board.render();
  scoreBoard.render();

  dasModal.close();
  delete currentMatchState.player2BRemoved;
};

const handleCodeClick = async (event) => {
  const gotClicked = event.target.id;
  if (
    ![
      "watcherCodeDiv",
      "copyWatcherURL",
      "playerCodeP2Div",
      "copyP2JoinURL",
      "playerCodeP1Div",
      "copyP1JoinURL",
      "generatePlayerCodeP1",
      "generatePlayerCodeP2",
      "generateWatcherCode",
    ].includes(gotClicked)
  ) {
    return; // probably overkill to check for this, but you never know...
  }
  const match = matchService.getCurrentMatch().currentMatch;
  const copied = document.getElementById("copied");
  switch (gotClicked) {
    case "playerCodeP1Div":
      navigator.clipboard.writeText(match.playerCodeP1);
      copied.classList.remove("hide");
      break;
    case "copyP1JoinURL":
      navigator.clipboard.writeText(
        `https://topagon.com/join?${match.playerCodeP1}`,
      );
      copied.classList.remove("hide");
      break;
    case "playerCodeP2Div":
      navigator.clipboard.writeText(match.playerCodeP2);
      document.getElementById("copied").classList.remove("hide");
      break;
    case "copyP2JoinURL":
      navigator.clipboard.writeText(
        `https://topagon.com/join?${match.playerCodeP2}`,
      );
      copied.classList.remove("hide");
      break;
    case "watcherCodeDiv":
      navigator.clipboard.writeText(match.watcherCode);
      document.getElementById("copied").classList.remove("hide");
      break;
    case "copyWatcherURL":
      navigator.clipboard.writeText(
        `https://topagon.com/join?${match.watcherCode}`,
      );
      copied.classList.remove("hide");
      break;
    case "generatePlayerCodeP1":
      const generatePlayerCodeP1 = document.getElementById(
        "generatePlayerCodeP1",
      );
      copied.classList.remove("hide");
      copied.innerText = "Loading...";
      generatePlayerCodeP1.style.cursor = "wait";
      document.body.style.cursor = "wait";
      await matchService.generatePlayerCodeP1();
      document.body.style.cursor = "default";
      generatePlayerCodeP1.style.cursor = "default";
      copied.classList.add("hide");
      copied.innerText = "Copied!";
      render("normal");
      break;
    case "generatePlayerCodeP2":
      const generatePlayerCodeP2 = document.getElementById(
        "generatePlayerCodeP2",
      );
      copied.classList.remove("hide");
      copied.innerText = "Loading...";
      generatePlayerCodeP2.style.cursor = "wait";
      document.body.style.cursor = "wait";
      await matchService.generatePlayerCodeP2();
      document.body.style.cursor = "default";
      generatePlayerCodeP2.style.cursor = "default";
      copied.classList.add("hide");
      copied.innerText = "Copied!";
      render("normal");
      break;
    case "generateWatcherCode":
      const generateWatcherCode = document.getElementById(
        "generateWatcherCode",
      );
      copied.classList.remove("hide");
      copied.innerText = "Submitting...";
      generateWatcherCode.style.cursor = "wait";
      document.body.style.cursor = "wait";
      await matchService.generateWatcherCode();
      document.body.style.cursor = "default";
      generateWatcherCode.style.cursor = "default";
      copied.classList.add("hide");
      copied.innerText = "Copied!";
      render("normal");
      break;
  }
};

const setFlexDir = () => {
  // manual responsive design because it's not about
  // viewport width. It's about the zoom level.
  const yourMatchesOwnerRow = document.getElementById("yourMatchesOwnerRow");
  if (currentMatch.getSize() === "normal") {
    if (zoom.getHexSide() > 35) {
      yourMatchesOwnerRow.classList.add("flexDirRow");
      yourMatchesOwnerRow.classList.remove("flexDirColumn");
      document.getElementById("yourMatchesP1").style.width = "50%";
      document.getElementById("yourMatchesP2").style.width = "50%";
      //document.getElementById("ymButtons").style.width = "50%";
    }
    if (zoom.getHexSide() <= 35) {
      yourMatchesOwnerRow.classList.remove("flexDirRow");
      yourMatchesOwnerRow.classList.add("flexDirColumn");
      document.getElementById("yourMatchesP1").style.width = "87%";
      document.getElementById("yourMatchesP2").style.width = "87%";
      document.getElementById("ymMenu").style.marginLeft = "0px";
    }
  }
};

// pillboxes
const renderOwnerTurnWinner = async (match) => {
  const ownerUserID = match.ownerUserID;
  const p1UserID = match.p1UserID;
  const p2UserID = match.p2UserID;
  switch (true) {
    case ownerUserID === p1UserID:
      const p1IsOwner = document.getElementById("p1IsOwner");
      p1IsOwner.innerHTML = "OWNER";
      p1IsOwner.style.backgroundColor = colors.getGameColor("double");
      break;
    case ownerUserID === p2UserID:
      const p2IsOwner = document.getElementById("p2IsOwner");
      p2IsOwner.innerHTML = "OWNER";
      p2IsOwner.style.backgroundColor = colors.getGameColor("double");
      break;
  }
  switch (true) {
    case match.turn === p1UserID:
      const p1sTurn = document.getElementById("p1sTurn");
      p1sTurn.innerHTML = "TURN";
      p1sTurn.style.backgroundColor = colors.getGameColor("double");
      break;
    case match.turn === p2UserID:
      const p2sTurn = document.getElementById("p2sTurn");
      p2sTurn.innerHTML = "TURN";
      p2sTurn.style.backgroundColor = colors.getGameColor("double");
      break;
  }
  // if both players are waiting, it's definitely p1's turn
  if (match.turn === "waiting" && match.p1UserID === "waiting") {
    const p1sTurn = document.getElementById("p1sTurn");
    p1sTurn.innerHTML = "TURN";
    p1sTurn.style.backgroundColor = colors.getGameColor("double");
    return;
  }
  if (match.turn === "waiting" && match.p2UserID === "waiting") {
    const p2sTurn = document.getElementById("p2sTurn");
    p2sTurn.innerHTML = "TURN";
    p2sTurn.style.backgroundColor = colors.getGameColor("double");
    return;
  }
  // winner
  switch (true) {
    case match.winnerName === match.p1Name:
      const p1IsWinner = document.getElementById("p1IsWinner");
      p1IsWinner.innerHTML = "WINNER";
      p1IsWinner.style.backgroundColor = colors.getGameColor("double");
      break;
    case match.winnerName === match.p2Name:
      const p2IsWinner = document.getElementById("p2IsWinner");
      p2IsWinner.innerHTML = "WINNER";
      p2IsWinner.style.backgroundColor = colors.getGameColor("double");
      break;
  }

  //draw offered by whomever's turn it is
  // if it's your turn, you get the pillbox
  if (match.state === "drawOffered" && match.turn === match.p1UserID) {
    const p1IsDrawOffered = document.getElementById("p1IsDrawOffered");
    p1IsDrawOffered.innerHTML = "DRAW OFFERED";
    p1IsDrawOffered.style.backgroundColor = colors.getGameColor("double");
  }
  if (match.state === "drawOffered" && match.turn === match.p2UserID) {
    const p2IsDrawOffered = document.getElementById("p2IsDrawOffered");
    p2IsDrawOffered.innerHTML = "DRAW OFFERED";
    p2IsDrawOffered.style.backgroundColor = colors.getGameColor("double");
  }
};

const handleDecideDrawButton = () => {
  close();
  matchDraw.handleDecideDraw();
};

//
const renderBackgrounds = () => {
  document.getElementById("yourMatchesP1").style.backgroundColor =
    colors.getGameColor("tip");
  document.getElementById("yourMatchesP2").style.backgroundColor =
    colors.getGameColor("tip");
  // document.getElementById("ymVisibility").style.backgroundColor =
  //   colors.getGameColor("tip");

  // can't assume the codes are in the dom
  const YourMatchesCodeRow = document.getElementById("YourMatchesCodeRow");
  if (document.body.contains(YourMatchesCodeRow)) {
    YourMatchesCodeRow.style.backgroundColor = colors.getGameColor("tip");
  }
};

//pillbox
const renderState = (stateValue) => {
  const stateElement = document.getElementById("currentMatchState");
  stateElement.style.backgroundColor = colors.getGameColor("double");
  if (typeof stateValue === "undefined") {
    stateValue = "n/a";
  }
  stateValue = matchService.getFriendlyState(stateValue);
  stateElement.textContent = stateValue.toUpperCase();
};

//pillbox
const renderVisibility = (visibilityValue) => {
  const visibilityElement = document.getElementById("currentMatchVisibility");
  visibilityElement.style.backgroundColor = colors.getGameColor("double");
  if (typeof visibilityValue === "undefined") {
    visibilityValue = "n/a";
  }
  if (visibilityValue === "invited") {
    visibilityValue = "Invitation Only";
  }
  if (visibilityValue === "everyone") {
    visibilityValue = "Public";
  }
  visibilityElement.textContent = visibilityValue.toUpperCase();
};

const handleManageWatchers = async () => {
  const result = await matchService.getCurrentMatch();

  const match = result.currentMatch;

  const page = currentMatchState.page;
  const itemsOnPage = currentMatchState.itemsOnPage;
  const startIndex = page * itemsOnPage;
  const totalItems = match.watchers.length;
  let endIndex = totalItems;
  if (endIndex > startIndex + itemsOnPage) {
    endIndex = startIndex + itemsOnPage;
  }
  const totalPages = Math.ceil(totalItems / itemsOnPage);
  currentMatchState.totalPages = totalPages;

  let watcherNamesHtml = `<div id="listOWatchers">`;
  const manageWatchersButton = document.getElementById("manageWatchersButton");
  document.body.style.cursor = "wait";
  manageWatchersButton.style.cursor = "wait";
  manageWatchersButton.disabled = true;
  manageWatchersButton.textContent = "Loading...";
  for (let i = startIndex; i < endIndex; i++) {
    const watcherID = match.watchers[i];
    const watcherIdentity = await identityService.getIdentity(watcherID);
    let watcherName = watcherID; //default
    if (watcherIdentity.status === 200) {
      watcherName = watcherIdentity.identity.name; // show their full name if we got it
    }
    watcherNamesHtml =
      watcherNamesHtml + identityCard.generateHTML(watcherIdentity.identity);
  }
  watcherNamesHtml = watcherNamesHtml + "</div>";

  const html = `
  <div id="manageWatchersContainer">
    <br>
    <div>Remove a Watcher</div>
    <div>There are ${
      match.watchers.length
    } people watching this match. Click a name to remove them.</div>
    <br>
    ${watcherNamesHtml}
    <div id="cmPrevNext">
          <div id="cmPrevious">Previous</div>
          <div id="cmNext">Next</div> (Page ${page + 1} of ${totalPages})
        </div>
  </div>`;
  dasModal.close();
  dasModal.render(html);
  document.getElementById("cmPrevious").style.backgroundColor =
    colors.getGameColor("tip");
  document.getElementById("cmNext").style.backgroundColor =
    colors.getGameColor("tip");
  document.body.style.cursor = "default";
  manageWatchersButton.style.cursor = "default";
  manageWatchersButton.disabled = false;
  manageWatchersButton.textContent = manageWatchersButtonText(match);
  colors.setButtonColors();

  if (endIndex > startIndex + itemsOnPage) {
    endIndex = startIndex + itemsOnPage;
  }
  for (let i = startIndex; i < endIndex; i++) {
    const watcherID = match.watchers[i];
    eventHub.registerEvent("click", watcherID, handleRemoveWatcher);
    eventHub.registerEvent("pointerover", watcherID, handleicPointerOver);
    eventHub.registerEvent("pointerout", watcherID, handleicPointerOut);
    const card = document.getElementById(watcherID);
    card.style.backgroundColor = colors.getGameColor("tip");
  }
};

const handleicPointerOver = (event, element) => {
  element.style.backgroundColor = colors.getGameColor("iPop");
};

const handleicPointerOut = (event, element) => {
  element.style.backgroundColor = colors.getGameColor("tip");
};

const handleRemoveWatcher = async (event, element) => {
  document.body.style.cursor = "wait";
  const gotClicked = element.id;
  const result = await matchService.removeWatcher(gotClicked);
  dasModal.close();
  document.body.style.cursor = "default";
  if (result.status === 200) {
    dasModal.render("<div class=max>The watcher was removed</div>");
  } else {
    dasModal.render(
      `<div class=max>Watcher not removed. There was an error trying to remove the watcher.</div>`,
    );
  }
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
};

const handleFilterPointerOver = (event, element) => {
  element.classList.add("shadow");
  element.style.background = colors.getGameColor("iPop");
};

const handlePointerOutPrevNext = (event, element) => {
  element.classList.remove("shadow");
  element.style.background = colors.getGameColor("lighterAccent");
};

const handleClickPrevNext = (event, element) => {
  const gotClicked = element.id;
  if (
    gotClicked === "cmNext" &&
    currentMatchState.page < currentMatchState.totalPages - 1
  ) {
    currentMatchState.page++;
  }
  if (gotClicked === "cmPrevious" && currentMatchState.page > 0) {
    currentMatchState.page--;
  }
  handleManageWatchers();
};

eventHub.registerEvent("click", "ModalBehinderCloseCurrentMatch", close); //modalBehinder
eventHub.registerEvent("click", "stateSplainer", renderStateSplainer);
eventHub.registerEvent("click", "closeYourMatches", close);
eventHub.registerEvent("click", "currentMatchNav", handleCurrentMatchClick);
eventHub.registerEvent("click", "removeP1", handleRemovePlayer);
eventHub.registerEvent("click", "removeP2", handleRemovePlayer);
eventHub.registerEvent("click", "offerDraw", matchDraw.handleOfferDraw);
eventHub.registerEvent(
  "click",
  "ymResume",
  matchDraw.handleResumeAfterDeclineButtonClick,
);
eventHub.registerEvent("click", "resignButton", resign.handleNotifyResign);
eventHub.registerEvent("click", "cancelButton", cancel.handleCancelRequest);
eventHub.registerEvent("click", "manageWatchersButton", handleManageWatchers);
eventHub.registerEvent("click", "noRemove", handleNoRemove);
eventHub.registerEvent("click", "yesRemove", handleYesRemove);

eventHub.registerEvent("click", "stopWatchingButton", handleStopWatchingButton);
eventHub.registerEvent("click", "noStop", handleNoStop);
eventHub.registerEvent("click", "yesStop", handleYesStop);

eventHub.registerEvent("click", "withdrawSplainer", renderWithdrawSplainer);
eventHub.registerEvent("click", "currentMatchMessageSplainer", renderCurrentMatchMessageSplainer);
eventHub.registerEvent("click", "withdrawButton", handleWithdrawButton);
eventHub.registerEvent("click", "noWithdraw", handleNoWithdraw);
eventHub.registerEvent("click", "yesWithdraw", handleYesWithdraw);

eventHub.registerEvent("click", "generatePlayerCodeP1", handleCodeClick);
eventHub.registerEvent("click", "playerCodeP1Div", handleCodeClick);
eventHub.registerEvent("click", "copyP1JoinURL", handleCodeClick);

eventHub.registerEvent("click", "generatePlayerCodeP2", handleCodeClick);
eventHub.registerEvent("click", "playerCodeP2Div", handleCodeClick);
eventHub.registerEvent("click", "copyP2JoinURL", handleCodeClick);

eventHub.registerEvent("click", "generateWatcherCode", handleCodeClick);
eventHub.registerEvent("click", "watcherCodeDiv", handleCodeClick);
eventHub.registerEvent("click", "copyWatcherURL", handleCodeClick);

eventHub.registerEvent("click", "p1DecideDrawButton", handleDecideDrawButton);
eventHub.registerEvent("click", "p2DecideDrawButton", handleDecideDrawButton);
eventHub.registerEvent(
  "click",
  "decideDrawButtonCurrentMatchButton",
  handleDecideDrawButton,
);
eventHub.registerEvent("pointerover", "cmPrevious", handleFilterPointerOver);
eventHub.registerEvent("pointerout", "cmPrevious", handlePointerOutPrevNext);
eventHub.registerEvent("click", "cmPrevious", handleClickPrevNext);

eventHub.registerEvent("pointerover", "cmNext", handleFilterPointerOver);
eventHub.registerEvent("pointerout", "cmNext", handlePointerOutPrevNext);
eventHub.registerEvent("click", "cmNext", handleClickPrevNext);

eventHub.registerEvent("click", "p1ARRSplainerlong", renderARRSplainerLong);
eventHub.registerEvent("click", "p2ARRSplainerlong", renderARRSplainerLong);

export const currentMatch = {
  render,
  getSize,
  setFlexDir,
  generateStateSplainerHTML,
};
